import { Grid, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import { ReactComponent as ChatBubbleIcon } from "assets/mail-chat-bubble-square-warning.svg";
import ThemeContext from "components/app/Context";
import Feedback from "components/common/Feedback";
import NoPlansBanner from "components/common/NoPlansBanner";
import TemplateItem from "components/common/plans/item";
import Scroller from "components/common/Scroller/InfiniteScroller";
import { fetchMyPlansAsync, setLoader } from "components/features/AboveProperty/AboveProperty.slice";
import FilterButtons from "components/features/AboveProperty/FilterButtons";
import { useContext, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { getBrandCodesForAboveProperties, getUserHltId } from "utils/CommonFunctions";
import { pageNames } from "../../../../utils/Types";
import MyPlansItem from "../item";
import { fetchOwnerDetailsAsync } from "../myplans.slice";
import TableHeader from "../TableHeader";

export const PROPERTY_PLAN = "PLAN";
export const TEMPLATE_PLAN = "TEMPLATE_PLAN";

interface Props {
  type?: string;
}
function List(props: Props) {
  const { type } = props;
  const isPropertyPlan = type === PROPERTY_PLAN;
  const { brands }: any = useAppSelector((state) => state?.aboveProperty);
  const {
    plansList,
    totalList,
    createNewPlan,
    inncodes: inncodeOptions
  }: any = useAppSelector((state) => state?.aboveProperty.planProgress);
  let myPlanfilters = useAppSelector(
    (state) => state?.aboveProperty.filters.myPlans[isPropertyPlan ? "propertyPlans" : "templatePlans"]
  );
  const [pageNo, setPageNo] = useState(0);
  const dispatch = useAppDispatch();
  const { isMobileScreen } = useContext(ThemeContext);
  const { functionalAreas, source, status, inncode, brandCodes, searchText } = myPlanfilters;

  const payloadData = {
    includeOwners: true,
    planType: type,
    searchText,
    searchedHltId: getUserHltId(),
    functionalArea: functionalAreas.join(","),
    planSources: source?.join(","),
    status: status?.join(","),
    innCode: inncode?.join(","),
    brandCode: getBrandCodesForAboveProperties(brandCodes, brands).join(",")
  };

  useEffect(() => {
    const getPlans = async () => {
      let planOwners: [] = [];
      const payload = {
        includeFilters: true,
        ...payloadData
      };
      const page = 0;
      const props = { payload, page };
      const fetchPlans = await dispatch(fetchMyPlansAsync(props));
      planOwners = fetchPlans?.payload?.meta?.owners;
      if (planOwners?.length > 0) {
        const data = {
          value: planOwners,
          size: planOwners.length
        };
        await dispatch(fetchOwnerDetailsAsync(data));
      }
      dispatch(setLoader(false));
    };
    getPlans();
    setPageNo(0);
  }, [dispatch, myPlanfilters, createNewPlan]);

  const fetchMore = () => {
    const page = pageNo + 1;
    const props = { payload: payloadData, page };

    dispatch(fetchMyPlansAsync(props));
    setPageNo(pageNo + 1);
  };

  return (
    <>
      <Feedback form="fetchMyPlans" />
      <FilterButtons
        isSearchBarVisible
        isFunctionalAreaVisible
        isInncodeVisible={isPropertyPlan}
        optionsList={{ inncode: inncodeOptions }}
        isSourceVisible={isPropertyPlan}
        isStatusVisible={isPropertyPlan}
        isBrandsVisible={isPropertyPlan}
        filterType={isPropertyPlan ? "propertyPlans" : "templatePlans"}
        parentView="myPlans"
      />
      {!isMobileScreen && isPropertyPlan && <TableHeader />}
      <Grid container marginTop={isMobileScreen ? "-16px" : "0px"} marginBottom="24px">
        {plansList?.length ? (
          <Scroller dataLength={plansList.length} loadMore={fetchMore} totalList={totalList} label="Plans">
            {plansList.map((plan: any) => {
              return isPropertyPlan ? (
                <MyPlansItem key={plan.id} plan={plan} />
              ) : (
                <TemplateItem key={plan.id} item={plan} />
              );
            })}
          </Scroller>
        ) : (
          <>
            {isPropertyPlan ? (
              <NoPlansBanner pageName={pageNames.myPlans} />
            ) : (
              <Stack
                spacing={3}
                alignItems="center"
                justifyContent="center"
                sx={{
                  backgroundColor: tokens.Background.General.Secondary,
                  minHeight: "500px",
                  width: "100%",
                  padding: "8px, 16px, 8px, 16px",
                  borderRadius: "8px",
                  gap: "24px",
                  border: `1px solid ${tokens.Border.General.Secondary}`
                }}
              >
                <ChatBubbleIcon />
                <Typography variant="body1" color={tokens.Text.General.Tertiary}>
                  You have no {isPropertyPlan ? "Property" : "Template"} Plans yet
                </Typography>
              </Stack>
            )}
          </>
        )}
      </Grid>
    </>
  );
}

export default List;
